var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(['admin', 'store'].includes(_vm.user.role))?_c('dashboard-view'):(_vm.user.role === 'delivery')?_c('home-driver'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }